<template>
    <div>
        <Modal
                :mask-closable="false"
                v-model="show_tags"
                title="标签选择"
                width="700"
        >
            <div slot="close" @click="cancelTag">
                <i class="ivu-icon ivu-icon-ios-close"></i>
            </div>
            <div v-if="tags_list.length == 0" style="text-align: center">暂无数据<span style="cursor:pointer;color:#3F8CFF" @click="refresh">刷新</span></div>
            <div v-if="tags_list.length > 0" class="tags-border" v-for="(item, index) in tags_list" :key="index">
                <div class="tags-title">
                    {{item.group_name}}
                </div>
                <div class="tags-content">
                    <CheckboxGroup v-model="selected_tag">
                        <Checkbox :label="t.id+'，'+t.name"  border  v-for="(t, i) in item.tag"  :key="i">{{t.name}}</Checkbox>
                    </CheckboxGroup>
                </div>
            </div>

            <div slot="footer" v-if="tags_list.length > 0" >
                <Button  type="primary" @click="submitOk"  >确定</Button >
            </div>
        </Modal>
    </div>
</template>

<script>
    import {tags_select, set_customer_tag} from "@/api/system"
    export default {
        name: "Tags",
        data(){
            return{
                tags_list:[],
                selected_tag:[]
            }
        },
        props:{
            show_tags:{
                type:Boolean,
                default:false
            },
            is_return:{
                type:Boolean,
                default:false
            },
           customer_id:{
               default:0
           },
           tags_active:{
               type:Array,
               default:function(){
                   return []
               }
           },
        },
        created(){

        },
        watch:{
            tags_active:{
                handler:function(val){
                    this.selected_tag = val
                }
            }
        },
        mounted() {
            this.get_tags()
        },
        methods:{
            get_tags(){
                tags_select().then(res=>{
                    if(res.code == 200) {
                        this.tags_list = res.data
                        this.tags_list.filter(function(item,index){
                            if(item.tag != "") {
                                item.tag = JSON.parse(item.tag)
                            }
                        })
                    }
                })
            },
            submitOk(){
                var arr = [], a
                for (var i in this.selected_tag) {
                    a = this.selected_tag[i].split("，")
                    arr.push({"tag_id":a[0], "tag_name":a[1]})
                }
                if (this.is_return) {
                    this.$emit("return_data", arr);return
                }

                this.$Message.info({
                    content: '设置标签中，请等待',
                    duration: 0
                });
                set_customer_tag({list:arr, customer_id:this.customer_id}).then(res=>{
                    this.$Message.destroy()
                    if(res.code == 200) {
                        this.$emit("hide_lable", 1)
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            cancelTag(){
                this.$emit("hide_lable", 2)
            },
            refresh(){
                this.get_tags();
            }
        }
    }
</script>

<style scoped>
.tags-border:first-child{
    padding-top:0
}
.tags-border{
    border-bottom:1px solid #e4effa;
    padding: 10px 0
}
.tags-border .tags-title{
    font-size:14px;font-weight: bold
}
.tags-border .tags-content{
    margin-top:5px
}
.tags-border .tags-content  .ivu-checkbox-group-item{
    margin:5px
}
</style>
